// extracted by mini-css-extract-plugin
module.exports = {"jumpToWxMini_content":"jumpToWxMini_jumpToWxMini_content__1dNRC","img_wrap":"jumpToWxMini_img_wrap__3H022","img_text":"jumpToWxMini_img_text__2y68D"};